import log from '@uwm/logger';

import aemClientService from '@/services/aem/aemClientService';
import type {MarketConfigModel, MarketContentModel} from '@/types/aem';

let content: MarketContentModel = {};
let config: MarketConfigModel = {};

/** A failed fetch is not fatal: the module renders without it. */
const loadOrEmpty = async <T extends object>(label: string, load: () => Promise<T>): Promise<T> => {
    try {
        return await load();
    } catch (error) {
        log.warn(`content: AEM market ${label} unavailable`, (error as Error).message);

        return {} as T;
    }
};

export const initContent = async (marketName: string, languageCode: string) => {
    const market = marketName?.toLowerCase();

    [content, config] = await Promise.all([
        loadOrEmpty('content', () =>
            aemClientService.initMarketContent<MarketContentModel>(market, languageCode?.toLowerCase())
        ),
        loadOrEmpty('config', () => aemClientService.initMarketConfig<MarketConfigModel>(market)),
    ]);
};

export const getContent = (): MarketContentModel => content;

export const getConfig = (): MarketConfigModel => config;
